'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i]; return arr2; } else { return Array.from(arr); } }

class KinoPromise extends Promise {
    spread(onFulfilled, onRejected) {
        function onFulfilledInternal(res) {
            if (Array.isArray(res)) {
                return onFulfilled.apply(undefined, _toConsumableArray(res));
            }
        };

        return this.then(onFulfilledInternal, onRejected);
    }
}

KinoPromise.all = function KinoPromise_static_all(promises) {
    if (arguments.length > 1 || typeof promises !== 'object') {
        return Promise.all.apply(Promise, arguments);
    }

    return new KinoPromise((resolve, reject) => {
        const isPromisesList = Array.isArray(promises);
        let promisesArray;
        let promisesKeys;

        if (isPromisesList) {
            promisesArray = promises;
        } else {
            promisesKeys = Object.keys(promises);
            promisesArray = promisesKeys.map(key => promises[key]);
        }

        Promise.all(promisesArray).then(res => {
            // transform output into an object
            let output;

            if (isPromisesList) {
                output = res;
            } else {
                output = res.reduce((output, chunk, index) => {
                    output[promisesKeys[index]] = chunk;
                    return output;
                }, {});
            }

            resolve(output);
        }).catch(reject);
    });
};

exports.default = KinoPromise;
module.exports = exports['default'];



// WEBPACK FOOTER //
// ./~/kinopromise/build.js